module.exports = __webpack_public_path__ + "cda44f6c77580cc69154efcd32aebe2e.pdf";